import React, { createRef } from "react";
import { LanguageContext } from "../Utilities/LanguageContext";
import { injectIntl } from "react-intl";
import "./contact.css";
import MaxButton from "./MaxButton";
import MenuItem from "@material-ui/core/MenuItem";
// import MailCountry from "./MailCountry";
import MaxFooter from "./Footer";
import {
  getFM,
  // getSpan,
  isPortrait,
  isProd,
  ScrollSnap,
} from "../Utilities/utils";
import MainMenu from "./menu/menu";
// import emailjs from 'emailjs-com';
import { Select, TextField } from "@material-ui/core";
import gsap from "gsap";
import { logEvent } from "../Utilities/AmplitudeService";

const NEXT_PUBLIC_NEWSLETTER = window.location.hostname.includes("staging")
  ? "https://newsletter.itools-staging.etermax.com/api/contact/bg"
  : window.location.hostname === "localhost"
  ? "https://newsletter.itools-staging.etermax.com/api/contact/bg"
  : "https://newsletter.itools.etermax.com/api/contact/bg";

class Contact extends React.Component {
  static contextType = LanguageContext;

  constructor(props, context, intl) {
    super(props);
    this.cc = createRef();
    this.Subscribe = createRef();
    this.contactForm = createRef();
    this.nameText = createRef();
    this.emailText = createRef();
    this.errText = createRef();
    this.state = {
      name: "",
      email: "",
      how: "",
      message: "",
    };
    this.buttonProps = isPortrait()
      ? {}
      : {
          bgColor: "var(--formColor",
          color: "var(--formBG)",
        };
    this.sendEmail = this.sendEmail.bind(this);
  }

  componentDidMount() {
    this.initialState = {
      name: "",
      email: "",
      how: this.props.intl.formatMessage({ id: "contact_form_how0" }),
      message: "",
    };
    document.getElementById("scroll-icon").style.display = "none";
    logEvent("contact_loaded");
    this.setState(this.initialState);

    const ss = this.cc.current.offsetHeight / 3;
    if (isPortrait()) {
      ScrollSnap(ss);
    }

    window.scrollTo(
      0,
      window.location.href.toLowerCase().includes("#subscribe") ? ss : 0
    );

    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".contact-form-container accessibility-img",
          start: "end",
          end: "+=60%",
          scrub: true,
        },
      })
      .fromTo(
        ".top-menu",
        {
          height: 0,
        },
        { height: "inherit" },
        1
      );

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }

  doneMessage(msg, reset) {
    this.errText.current.innerText = msg;
    gsap.fromTo(
      this.errText.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        yoyo: true,
        duration: 0.5,
        repeatDelay: 4,
        repeat: 1,
        onComplete: () => {
          if (reset) this.setState(this.initialState);
        },
        onReverseComplete: () => {
          if (reset) this.setState(this.initialState);
        },
      },
      "0"
    );
  }

  sendEmail() {
    if (this.state.name !== "" && this.state.email !== "") {
      const data = {
        name: this.state.name,
        email: this.state.email,
        subject: this.state.subject,
        message: `How: ${this.state.how} - Message: ${this.state.message}`,
      };

      fetch(
        `${NEXT_PUBLIC_NEWSLETTER}${
          this.props.intl.locale.toLowerCase() === "pt" ? "-pt" : ""
        }`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      )
        .then((res) => {
          if (res.status === 200) {
            this.doneMessage(
              this.props.intl.formatMessage({ id: "contact_form_reply" }),
              true
            );
          } else {
            this.doneMessage("ERROR", false);
          }
        })
        .catch((e) => {
          this.doneMessage("UNKNOW_ERROR", false);
        });
    } else {
      const errTL = gsap.timeline();
      const errP = {
        yoyo: true,
        duration: 0.04,
        repeatDelay: 0.02,
        repeat: 9,
        x: "+=0.3vw",
        paused: false,
      };

      if (this.state.name === "") {
        errTL.to(this.nameText.current, errP, "0");
      }
      if (this.state.email === "") {
        errTL.to(this.emailText.current, errP, "0");
      }

      this.errText.current.innerText = this.props.intl.formatMessage({
        id: "contact_form_error",
      });
      errTL.fromTo(
        this.errText.current,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          yoyo: true,
          duration: 0.5,
          repeatDelay: 2,
          repeat: 1,
        },
        "0"
      );

      errTL.play();
    }
  }

  getTemplateID() {
    const template = "template_" + (isProd ? "59t6uhp" : "test");
    return template;
  }

  getTextField(props) {
    const { required, ...fld } = props;
    return (
      <TextField
        {...fld}
        className={"contact-text accessibility-font "}
        InputProps={{
          className: "contact-text",
          required: required,
          type: fld.name === "email" ? "email" : "text",
        }}
        InputLabelProps={{ className: "contact-text" }}
        label={this.props.intl.formatMessage({
          id: "contact_form_" + fld.name,
        })}
        value={this.state[fld.name]}
        onChange={(e) => this.setState({ [fld.name]: e.target.value })}
      />
    );
  }

  render() {
    return (
      <>
        <section ref={this.cc} className="content contact-container">
          <div id={"contactId"} className="contact-text-container clip-all">
            <div className="contact-title">
              <span>{getFM("contact_title")}</span>
              <br />
            </div>
          </div>
          <div className="contact-form-container accessibility-img">
            <form
              className={"contact-form"}
              ref={this.contactForm}
              name={"contact"}
            >
              <span className="contact-form-title">
                {!isPortrait() && getFM("contact_form_header")}
              </span>
              {this.getTextField({
                name: "name",
                required: true,
                ref: this.nameText,
              })}
              {this.getTextField({
                name: "email",
                required: true,
                ref: this.emailText,
              })}
              {this.getTextField({ name: "subject", required: false })}
              <section className={"sep"} />
              <Select
                className="contact-text accessibility-font"
                name="how"
                onChange={(e) => this.setState({ how: e.target.value })}
                value={this.state.how}
                MenuProps={{
                  classes: { paper: "select-menu", list: "select-menu-item" },
                }}
                styles={{
                  dropdownIndicator: (styles) => ({
                    ...styles,
                    color: "#ee303b",
                    fontWeight: "900",
                  }),
                }}
              >
                {Array(7)
                  .fill("contact_form_how")
                  .map((txt, index) => (
                    <MenuItem
                      key={txt + index}
                      value={this.props.intl.formatMessage({ id: txt + index })}
                      disabled={index === 0}
                      className={"select-menu-item"}
                    >
                      {getFM(txt + index)}
                    </MenuItem>
                  ))}
              </Select>
              <section className={"sep"} />
              <TextField
                onChange={(e) => this.setState({ message: e.target.value })}
                value={this.state.message}
                multiline
                variant="outlined"
                rows={4}
                InputProps={{ className: "contact-text" }}
                InputLabelProps={{ className: "contact-text" }}
                className="contact-text accessibility-font"
                name="message"
                label={this.props.intl.formatMessage({
                  id: "contact_form_message",
                })}
              />
              <span ref={this.errText} className="msg-text accessibility-font">
                {this.state.doneMessage}
              </span>

              <div className={"sendButton"}>
                <MaxButton
                  {...this.buttonProps}
                  clickEvent={() => {
                    logEvent("contact_sent");
                    this.sendEmail();
                  }}
                >
                  contact_form_button
                </MaxButton>
              </div>
            </form>
          </div>
          <div className={"news-form"} ref={this.Subscribe}>
            <section className={"mail-section"}>
              {/* <div className={"mail-font mail-area"}>
                {isPortrait() && <div className={"form-div"} />}
                {getSpan(
                  [
                    "home_carrousel_subscription_txt",
                    "home_carrousel_subscription_txt_2",
                  ],
                  "ms",
                  " "
                )}
              </div> */}
              {/* <MailCountry id={"mail-country"} className={"mail-area"} /> */}
            </section>
          </div>
          <MaxFooter />
        </section>
        <MainMenu
          showPopup={false}
          autoPlay={true}
          topMenu={"#191919"}
          iconScroll={isPortrait() ? "icon-scroll-right" : ""}
          hide={
            isPortrait()
              ? ["#to-top-icon", "#contact-icon", "#ac", "#at"]
              : ["#to-top-icon", "#contact-icon"]
          }
          triggerId={"#contactId"}
          end={"top -50%"}
        />
      </>
    );
  }
}

export default injectIntl(Contact);
